(function () {
  const KEY = 'sb_config_v1';

  function safeParse(s) {
    try { return JSON.parse(s || '{}') || {}; } catch (e) { return {}; }
  }

  function read() {
    return safeParse(localStorage.getItem(KEY));
  }

  function write(obj) {
    localStorage.setItem(KEY, JSON.stringify(obj || {}));
  }

  function patch(p) {
    const current = read();
    const next = { ...current, ...(p || {}) };
    write(next);
    return next;
  }

  function clear() {
    localStorage.removeItem(KEY);
  }

  window.SBConfig = {
    KEY,
    read,
    write,
    patch,
    clear
  };
})();
